import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

export default function ConfirmationScreen({
  handleClose,
  component,
  open,
  maxWidth,
  title,
  imgSrc,
}) {
  return (
    <>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px", // 👈 custom border radius here
          },
        }}
      >
        <DialogTitle
          textAlign="start"
          color="#FFFFFF"
          mb={2}
          fontFamily="Inter"
          fontSize="18px"
          style={{ background: "#572575", fontWeight: 400 }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Box width={35} height={35}>
              <img src={imgSrc} />
            </Box>{" "}
            <Typography
              textAlign="start"
              color="#FFFFFF"
              fontFamily="Inter"
              fontSize="19px"
              lineHeight="100%"
              letterSpacing="0px"
              style={{ background: "#572575", fontWeight: 400 }}
            >
              {title ? title : ""}{" "}
            </Typography>
          </Box>
          <IconButton
            edge="end"
            onClick={handleClose}
            aria-label="close"
            sx={{ position: "absolute", right: 15, top: 2, color: "#FFFFFF" }}
          >
            <CloseIcon fontSize="medium" />
          </IconButton>
        </DialogTitle>
        <DialogContent>{component}</DialogContent>
      </Dialog>
    </>
  );
}
